import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  privyLogin    : ["email", "google", "apple"],
  currentDialog : {
    name  : null,
    props : null,
  },
  slug           : null,
  initialLoading : true,
};

const slice = createSlice({
  name     : "global",
  initialState,
  reducers : {
    setPrivyLogin         : (state, action) => ({ ...state, privyLogin: action.payload }),
    setCurrentDialog      : (state, action) => ({ ...state, currentDialog: action.payload }),
    setSlug               : (state, action) => ({ ...state, slug: action.payload }),
    disableInitialLoading : state => ({ ...state, initialLoading: false }), // Following studio pattern
  },
});

export const { setPrivyLogin, setCurrentDialog, setSlug, disableInitialLoading } = slice.actions;

export default slice.reducer;
